import api from '@utils/http'

/**
 * 检查是否绑定手机号，如果绑定返回绑定手机号
 * @param {}  
 */
export const apiCheckBindPhone = p=>api.post('loginAndRegister/whetherBindingMobile',p)
/**
 * 绑定手机发送验证码
 * @param {mobile}  
 */
export const apiSendCodeBindPhone = p=>api.post('loginAndRegister/sendMsgBindingMobile',p)
/**
 * 绑定手机号
 * @param {mobile,rand}  
 */
export const apiSubmitBindPhone = p=>api.post('loginAndRegister/bindingMobile',p)